<ng-container *ngIf="date">
    <span class="text-primary">
        <h3 *ngIf="day > 0" class="d-inline">{{day}}</h3> <span *ngIf="day > 0"> {{ 'DAYS' | translate:{singularPlural: transform(day)} }}&nbsp;</span>
        <h3 *ngIf="hour > 0" class="d-inline">{{hour}}</h3><span *ngIf="hour > 0"> {{ 'HOURS_LEADERBOARD' | translate:{singularPlural: transform(hour)} }}&nbsp;</span> 
        <h3 class="d-inline">{{minutes}}</h3> {{ 'MINUTES_LEADERBOARD' | translate:{singularPlural: transform(minutes)} }}</span>
</ng-container>